<template>
  <ul class="seo-search">
    <li
      v-for="(item, index) in items"
      :key="index"
    >
      <a
        :href="item.href"
        :title="item.q"
        :uigs="'out_query_' + index + '_' + item.q"
      >{{ item.q }}</a>
    </li>
  </ul>
</template>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_playlist.scss';
.seo-search {
  margin: 8px 20px;
  text-align: center;
  color: #222;
  font-size: 15px;
  line-height: 21px;
  > li {
    float: left;
    width: 48.5%;
    height: 56px;
    background: rgba(245, 245, 245, 1);
    border-radius: 5px;
    margin-right: 3%;
    margin-bottom: 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    overflow: hidden;

    > a {
      padding: 0 13px;
      color: #222;
      @include line-clip(2);
      word-break: break-all;
    }

    &:nth-child(2n) {
      margin-right: 0;
    }
  }
}
</style>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('qlist', ['items']),
  },
};
</script>
